import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=5d493920&scoped=true"
import script from "./AreaEdit.vue?vue&type=script&lang=js"
export * from "./AreaEdit.vue?vue&type=script&lang=js"
import style0 from "./AreaEdit.vue?vue&type=style&index=0&id=5d493920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d493920",
  null
  
)

export default component.exports